import { render, staticRenderFns } from "./ListVPage.vue?vue&type=template&id=07441f8e&scoped=true&"
import script from "./ListVPage.vue?vue&type=script&lang=js&"
export * from "./ListVPage.vue?vue&type=script&lang=js&"
import style0 from "./ListVPage.vue?vue&type=style&index=0&id=07441f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07441f8e",
  null
  
)

export default component.exports